module.exports = {"validation":{"required":"Це поле є обов’язковим","email":"Недійсна електронна адреса"}}